import { GetEcshopAccountsApi } from "@/features/accounts/ecshop/services/get-accounts-api";
import { GetEcshopAccountsRequestModel } from "@/features/accounts/ecshop/services/get-accounts-model";

/// その他連携サービス口座一覧取得処理
export class GetEcshopAccountsService {
  private getEcshopAccountsApi = new GetEcshopAccountsApi();

  /**
   * その他連携サービス口座一覧取得API実行
   */
  public async getEcshopAccounts(param: GetEcshopAccountsRequestModel) {
    return await this.getEcshopAccountsApi.getEcshopAccounts(param);
  }
}
